import type { SVGProps } from "react";

export default function TrendDownIcon({
  width = 20,
  height = 20,
  ...rest
}: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 11"
      fill="none"
      {...rest}
    >
      <path
        d="M17.2943 9.79431L11.1446 3.68206C10.3132 2.85577 9.89747 2.4426 9.38189 2.44266C8.86631 2.44272 8.45064 2.85597 7.61947 3.68247L7.42006 3.88081C6.58809 4.70806 6.17212 5.12172 5.65616 5.12147C5.14019 5.12131 4.72452 4.70739 3.8932 3.87956L0.62764 0.62764M12.6426 9.79431H17.2943V5.17281"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
